export const app = {
    name: 'Kisomi',
};
